export function absoluteURL(uri: string | undefined) {
  if (!uri) {
    return undefined;
  }
  if (uri.includes("http://") || uri.includes("https://")) {
    return uri;
  }
  return `${process.env.REACT_APP_DRUPAL_BASE_URL}${uri}`;
}
